import useGet from '../../../core/composables/api/useGet'
import type { Scale } from '@/core/models/scale'
import type { JournalAnalysis } from '@/core/components/journal-analysis/journal-analysis'
import type { FeedbackTopic } from '@/core/models/feedback-topic'
import { computed, watch, toValue, type MaybeRef } from 'vue'
import { useRoute } from 'vue-router'

export const useCoacheeJournalProfile = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()

  const coacheeId = computed(() => route.params.id as string)
  const journalEndpoint = computed(
    () => `coaching/coachee/${coacheeId.value}/profile/journal/${toValue(feedbackTopicId)}`,
  )

  const { data, status, load, reload } = useGet<{
    analysis: JournalAnalysis
    feedbackTopic: FeedbackTopic
  }>(journalEndpoint)

  watch(
    journalEndpoint,
    () => {
      load()
    },
    { immediate: true },
  )

  return {
    data,
    status,
    load,
    reload,
  }
}

export interface JournalProfile {
  readonly id: string
  readonly title: string
  readonly description?: string
  readonly icon?: string
  readonly scale: Scale
  readonly progress: ReadonlyArray<{
    readonly date: string
    readonly average: number
  }>
  readonly analysis: ReadonlyArray<JournalProfileAnalysis>
}

export interface JournalProfileAnalysis {
  readonly date: string
  readonly average: number
  readonly surveys: ReadonlyArray<ProfileJournalSurveyAnalysis>
}

export interface ProfileJournalSurveyAnalysis {
  readonly id: string
  readonly title: string | null
  readonly updatedAt: string
  readonly teamName?: string
  readonly average: number
  readonly feedbacks: ReadonlyArray<{
    readonly id: string
    readonly value: number | null
    readonly question: {
      readonly id?: string
      readonly text?: string
    }
  }>
}
